export default {
  inflect (num, uninflected, inflected) {
    if (num === 1) {
      return uninflected
    } else {
      return inflected
    }
  }
}
